module.exports = __webpack_public_path__ + "img/39_56.b14ec39b.png";